import React from "react";
import {
  GSTR_3B_BREAKUP_TAX_LIABILITY_DECLARED_HEADERS,
  GSTR_3B_FIVE_HEADERS,
  GSTR_3B_FIVE_POINT_ONE_HEADERS,
  GSTR_3B_FOUR_HEADERS,
  GSTR_3B_SIX_POINT_ONE_HEADERS,
  GSTR_3B_THREE_POINT_ONE_HEADERS,
  GSTR_3B_THREE_POINT_TWO_HEADERS,
  getGstrThreeBDataTemplate,
} from "../../../../constant/tableHeadersConstants/gst/gstr3bConstant";
import GstTableHeader from "../../common/GstTableHeader";
import GstrThreeBTableData from "./GstrThreeBTableData/index";
import Gstr3BSixPointOneTableHeader from "./Gstr3BSixPointOneTableHeader";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import { GstrThreeBDataType } from "../../../../commonTypes/gstTypes";

type AppProps = {
  item: any;
  gstrThreeBData: GstrThreeBDataType | {};
};
const GstrThreeBTable = ({ item, gstrThreeBData }: AppProps) => {
  const renderTableHeaders = (header: string) => {
    switch (header) {
      case "3.1 Details of Outward supplies and inward supplies liable to reserve charge":
        return GSTR_3B_THREE_POINT_ONE_HEADERS;
      case "3.1.1 Details of Supplies notified under section 9(5) of the CGST Act, 2017 and corresponding provisions in IGST/UTGST/ SGST Acts":
        return GSTR_3B_THREE_POINT_ONE_HEADERS;
      case "3.2 Out of supplies made in 3.1 (a) and 3.1.1 (i), details of inter-state supplies made":
        return GSTR_3B_THREE_POINT_TWO_HEADERS;
      case "4. Eligible ITC":
        return GSTR_3B_FOUR_HEADERS;
      case "5. Values of exempt, nil-rated and non-GST inward supplies":
        return GSTR_3B_FIVE_HEADERS;
      case "5.1 Interest and Late fee for previous tax period":
        return GSTR_3B_FIVE_POINT_ONE_HEADERS;
      case "6.1 Payment of tax":
        return GSTR_3B_SIX_POINT_ONE_HEADERS;
      case "Breakup of tax liability declared (for interest computation)":
        return GSTR_3B_BREAKUP_TAX_LIABILITY_DECLARED_HEADERS;
      default:
        return GSTR_3B_THREE_POINT_ONE_HEADERS;
    }
  };

  return (
    <div
      className={`gstr ${
        item?.header === "6.1 Payment of tax"
          ? "table-responsive thinScroll"
          : ""
      }`}
    >
      <table className="table table-bordered">
        <thead className="sticky-table-header  thead-light">
          {item?.header === "6.1 Payment of tax" ? (
            <Gstr3BSixPointOneTableHeader
              tableHeader={renderTableHeaders(item?.header)}
              type={"gstrForms"}
            />
          ) : (
            <GstTableHeader
              tableHeader={renderTableHeaders(item?.header)}
              type={"gstrForms"}
              rowSpan={item?.header === "6.1 Payment of tax" ? true : false}
            />
          )}
        </thead>

        <tbody>
          <GstrThreeBTableData
            tableHeader={item?.header}
            tableHeaderData={renderTableHeaders(item?.header)}
            data={getGstrThreeBDataTemplate(gstrThreeBData, " ", item?.header)}
            gstrThreeBData={gstrThreeBData}
            singleHeader={item?.header}
          />
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  gstrThreeBInvoiceList: state.gst.gstrThreeBInvoiceList,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GstrThreeBTable);
